/* =====================================================================
   pegconf-pdf.js — récapitulatif / devis indicatif PDF (lot E)
   =====================================================================
   Bouton dans la modale de devis (markup SSR dans pegconf.liquid).
   - montants exacts via PEGCONF.getPrice() / getInstances() ;
   - TVA : FR 20 % ; UE avec n° de TVA valide ET du pays de destination
     -> autoliquidation 0 % ; sinon TVA du pays ; hors UE -> export 0 %.
     Taux par défaut ci-dessous, surchargeables par pegconf.settings.vat_rates
     ({ "DE": 19, ... }) et vat_included_rates ;
   - référence DV-AAAAMMJJ-XXXX (suffixe aléatoire) partagée avec le
     formulaire de contact (champ « Reference devis ») ;
   - jsPDF auto-hébergé (assets/jspdf.umd.min.js, URL dans PEGCONF_PDF_CTX) ;
   - textes : PEGCONF_I18N (clés pdf_*), 6 langues.
   ===================================================================== */
(function () {
  'use strict';
  const root = document.getElementById('pegconf');
  if (!root) return;

  function start() {
    const P = window.PEGCONF, UI = window.PEGCONF_UI || {};
    const CTX = window.PEGCONF_PDF_CTX || {};
    const CFG = window.PEGCONF_CFG || {};
    const t = P.t;
    const lang = (window.PEGCONF_I18N && window.PEGCONF_I18N.lang) || 'fr';
    const $ = (id) => document.getElementById(id);

    const form = $('pegconf-quote-form'), btn = $('pegconf-pdf-btn'), err = $('pegconf-pdf-err');
    const countrySel = $('pegconf-q-country'), vatIn = $('pegconf-q-vat');
    if (!form || !btn) return;

    /* ---------- taux de TVA standard (2026) ---------- */
    const EU_RATES = Object.assign({
      AT: 20, BE: 21, BG: 20, HR: 25, CY: 19, CZ: 21, DK: 25, EE: 24, FI: 25.5, FR: 20,
      DE: 19, GR: 24, HU: 27, IE: 23, IT: 22, LV: 21, LT: 21, LU: 17, MT: 18, NL: 21,
      PL: 23, PT: 23, RO: 21, SK: 23, SI: 22, ES: 21, SE: 25
    }, (CFG.vat_rates && typeof CFG.vat_rates === 'object') ? CFG.vat_rates : {});
    /* taux inclus dans les prix affichés selon le pays du marché en cours */
    const INCLUDED_RATES = Object.assign({}, EU_RATES, { GB: 20, CH: 8.1 }, (CFG.vat_included_rates && typeof CFG.vat_included_rates === 'object') ? CFG.vat_included_rates : {});
    const VAT_PREFIX_TO_COUNTRY = { EL: 'GR', XI: 'GB' };

    function vatCheck(dest, raw) {
      const n = String(raw || '').toUpperCase().replace(/[\s.\-]/g, '');
      if (!n) return { given: false, formatOk: false, countryOk: false, value: '' };
      const formatOk = /^(AT|BE|BG|HR|CY|CZ|DK|EE|FI|FR|DE|EL|GR|HU|IE|IT|LV|LT|LU|MT|NL|PL|PT|RO|SK|SI|ES|SE|XI)[0-9A-Z]{2,12}$/.test(n);
      const prefix = n.slice(0, 2);
      const country = VAT_PREFIX_TO_COUNTRY[prefix] || prefix;
      return { given: true, formatOk, countryOk: formatOk && country === dest, value: n };
    }

    function showErr(msg) { if (!err) return; err.textContent = msg || ''; err.hidden = !msg; }
    const val = (name) => { const el = form.querySelector('[name="contact[' + name + ']"]'); return el ? (el.value || '').trim() : ''; };

    function collect() {
      const price = P.getPrice();
      const unitDisplayed = price ? price.totalCents / 100 : 0;
      let qty = parseInt(val('Quantite'), 10); if (!isFinite(qty) || qty < 1) qty = 1;
      const dest = countrySel ? countrySel.value : 'FR';
      const vat = vatCheck(dest, vatIn ? vatIn.value : '');
      const store = (CTX.storeCountry || 'FR').toUpperCase();
      const vatDiv = 1 + (INCLUDED_RATES[store] || 0) / 100;

      let rate, mention, warning = null;
      if (dest === 'FR') { rate = 20; mention = t('pdf_mention_fr'); }
      else if (EU_RATES[dest] != null) {
        if (vat.given && vat.formatOk && vat.countryOk) { rate = 0; mention = t('pdf_mention_eu_reverse'); }
        else {
          rate = EU_RATES[dest]; mention = t('pdf_mention_eu_b2c');
          if (vat.given && !vat.formatOk) warning = t('pdf_warn_tva');
          else if (vat.given && !vat.countryOk) warning = t('pdf_warn_tva_country');
        }
      } else { rate = 0; mention = t('pdf_mention_export'); }

      const rows = [];
      const panel = price ? price.panelCents / 100 : 0;
      rows.push({ desc: t('pdf_item_desc'), qty, unitHT: panel / vatDiv });
      const groups = {};
      P.getInstances().forEach((i) => {
        const unit = (parseInt(i.priceCents, 10) || 0) / 100;
        const key = (i.name || t('accessory_alt')) + '|' + unit;
        if (!groups[key]) groups[key] = { name: i.name || t('accessory_alt'), unit, count: 0 };
        groups[key].count++;
      });
      Object.keys(groups).forEach((k) => { const g = groups[k]; rows.push({ desc: g.name, qty: g.count * qty, unitHT: g.unit / vatDiv }); });
      rows.forEach((r) => { r.totalHT = r.unitHT * r.qty; });
      const totalHT = rows.reduce((s, r) => s + r.totalHT, 0);
      const tvaAmt = totalHT * rate / 100;

      const cfgInput = $('pegconf-quote-config');
      const cfgLines = ((cfgInput && cfgInput.value) || '').split('\n').map((l) => l.trim()).filter(Boolean);
      const linkInput = $('pegconf-quote-link');
      const refInput = $('pegconf-quote-ref');
      const ref = (refInput && refInput.value) || UI.quoteRef || ('DV-' + Date.now().toString(36).toUpperCase());
      if (refInput && !refInput.value) refInput.value = ref;

      return {
        unitDisplayed, rows, qty, rate, mention, warning, totalHT, tvaAmt, totalTTC: totalHT + tvaAmt,
        dest, destName: UI.countryName ? UI.countryName(dest) : dest, vat, ref,
        name: val('name'), email: val('email'), phone: val('phone'), company: val('Societe'), cp: val('CodePostal'), city: val('Ville'),
        cfgLines, link: linkInput ? linkInput.value : ''
      };
    }

    /* ---------- jsPDF (auto-hébergé) ---------- */
    let jsPdfPromise = null;
    function loadJsPdf() {
      if (window.jspdf && window.jspdf.jsPDF) return Promise.resolve();
      if (jsPdfPromise) return jsPdfPromise;
      jsPdfPromise = new Promise((resolve, reject) => {
        if (!CTX.jspdfUrl) { reject(new Error('jspdf url missing')); return; }
        const s = document.createElement('script');
        s.src = CTX.jspdfUrl; s.onload = () => resolve(); s.onerror = () => { jsPdfPromise = null; reject(new Error('jspdf load failed')); };
        document.head.appendChild(s);
      });
      return jsPdfPromise;
    }

    function blobDataUrl(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(reader.error || new Error('image read failed'));
        reader.readAsDataURL(blob);
      });
    }
    async function imageDataUrl(src) {
      if (!src || String(src).indexOf('data:') === 0) return src || '';
      const response = await fetch(src, { mode: 'cors', credentials: 'omit' });
      if (!response.ok) throw new Error('image fetch failed');
      return blobDataUrl(await response.blob());
    }
    function loadImage(src) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error('image decode failed'));
        img.src = src;
      });
    }
    async function configurationImage() {
      const preview = $('pegconf-preview');
      const svg = preview && preview.querySelector('svg');
      const calc = P.getCalc();
      if (!svg || !calc || !(calc.wMm > 0 && calc.hMm > 0)) return null;

      const Wmm = calc.wMm, Hmm = calc.hMm;
      const sr = svg.getBoundingClientRect(), vb = svg.viewBox.baseVal;
      const screenScale = Math.min(sr.width / vb.width, sr.height / vb.height);
      if (!(screenScale > 0)) return null;
      const panelLeft = sr.left + (sr.width - vb.width * screenScale) / 2 - vb.x * screenScale;
      const panelTop = sr.top + (sr.height - vb.height * screenScale) / 2 - vb.y * screenScale;
      const items = P.getInstances().map((inst) => {
        const r = inst.el.getBoundingClientRect();
        return { inst, el: inst.el, x: (r.left - panelLeft) / screenScale, y: (r.top - panelTop) / screenScale, w: r.width / screenScale, h: r.height / screenScale };
      }).filter((item) => item.w > 0 && item.h > 0);

      let minX = 0, minY = 0, maxX = Wmm, maxY = Hmm;
      items.forEach((item) => {
        minX = Math.min(minX, item.x); minY = Math.min(minY, item.y);
        maxX = Math.max(maxX, item.x + item.w); maxY = Math.max(maxY, item.y + item.h);
      });
      const contentW = Math.max(1, maxX - minX), contentH = Math.max(1, maxY - minY);
      const scale = Math.min(1400 / contentW, 900 / contentH);
      const pad = 36;
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.ceil(contentW * scale) + pad * 2);
      canvas.height = Math.max(1, Math.ceil(contentH * scale) + pad * 2);
      const ctx = canvas.getContext('2d');
      const ox = pad - minX * scale, oy = pad - minY * scale;

      const clone = svg.cloneNode(true);
      clone.querySelectorAll('.pegconf-person').forEach((node) => node.remove());
      clone.setAttribute('viewBox', '0 0 ' + Wmm + ' ' + Hmm);
      clone.setAttribute('width', String(Math.max(1, Math.round(Wmm * scale))));
      clone.setAttribute('height', String(Math.max(1, Math.round(Hmm * scale))));
      clone.setAttribute('preserveAspectRatio', 'none');
      const hole = svg.querySelector('.pegconf-hole');
      if (hole) clone.querySelectorAll('.pegconf-hole').forEach((node) => node.setAttribute('fill', getComputedStyle(hole).fill));
      const edge = svg.querySelector('.pegconf-edge');
      if (edge) clone.querySelectorAll('.pegconf-edge').forEach((node) => node.setAttribute('stroke', getComputedStyle(edge).stroke));
      const texture = svg.querySelector('.pegconf-texture');
      const textureVisible = texture && getComputedStyle(texture).display !== 'none';
      if (!textureVisible) clone.querySelectorAll('.pegconf-texture').forEach((node) => node.remove());
      await Promise.all(Array.from(clone.querySelectorAll('image')).map(async (node) => {
        const src = node.getAttribute('href') || node.getAttributeNS('http://www.w3.org/1999/xlink', 'href');
        try { node.setAttribute('href', await imageDataUrl(src)); }
        catch (e) { node.remove(); }
      }));
      const xml = new XMLSerializer().serializeToString(clone);
      const svgUrl = URL.createObjectURL(new Blob([xml], { type: 'image/svg+xml;charset=utf-8' }));
      try {
        const base = await loadImage(svgUrl);
        ctx.drawImage(base, ox, oy, Wmm * scale, Hmm * scale);
      } finally { URL.revokeObjectURL(svgUrl); }

      await Promise.all(items.map(async (item) => {
        const x = ox + item.x * scale, y = oy + item.y * scale, w = item.w * scale, h = item.h * scale;
        if (item.inst.type === 'text') {
          const span = item.el.querySelector('span'); if (!span) return;
          const rail = item.el.querySelector('.pegconf-text-rail');
          if (rail) {
            const rr = rail.getBoundingClientRect(), er = item.el.getBoundingClientRect();
            ctx.fillStyle = 'rgba(255,255,255,.6)';
            ctx.fillRect(x, y + (rr.top - er.top) / screenScale * scale, w, rr.height / screenScale * scale);
          }
          const st = getComputedStyle(span), fs = parseFloat(st.fontSize) / screenScale * scale;
          ctx.font = st.fontWeight + ' ' + fs + 'px ' + st.fontFamily;
          ctx.fillStyle = st.color; ctx.textBaseline = 'alphabetic';
          ctx.fillText(span.textContent || '', x, y + fs * .82);
          return;
        }
        const imgEl = item.el.querySelector('img');
        const src = imgEl && (imgEl.currentSrc || imgEl.src);
        if (!src) return;
        try { ctx.drawImage(await loadImage(await imageDataUrl(src)), x, y, w, h); }
        catch (e) { console.warn('[pegconf-pdf] accessoire non intégré à l’aperçu', e); }
      }));
      return { dataUrl: canvas.toDataURL('image/png'), width: canvas.width, height: canvas.height };
    }
    const LOCALES = { fr: 'fr-FR', en: 'en-GB', de: 'de-DE', es: 'es-ES', it: 'it-IT', nl: 'nl-NL' };
    function money(n) {
      try { return new Intl.NumberFormat(LOCALES[lang] || 'fr-FR', { style: 'currency', currency: CTX.currency || P.currency || 'EUR' }).format(n).replace(/[  ]/g, ' '); }
      catch (e) { return n.toFixed(2) + ' ' + (CTX.currency || 'EUR'); }
    }
    /* Helvetica WinAnsi : on neutralise les caractères hors Latin-1 (emoji, guillemets exotiques) */
    const safe = (s) => String(s == null ? '' : s).replace(/[‘’]/g, "'").replace(/[“”«»„]/g, '"').replace(/…/g, '...').replace(/[^ -ÿ€–—•]/g, '');

    function buildPdf(d) {
      const jsPDF = window.jspdf.jsPDF;
      const doc = new jsPDF({ unit: 'mm', format: 'a4' });
      const W = 210, M = 18; let y = 20;
      const now = new Date(), two = (n) => (n < 10 ? '0' : '') + n;
      const dateStr = two(now.getDate()) + '/' + two(now.getMonth() + 1) + '/' + now.getFullYear();
      const text = (s, x, yy, opt) => doc.text(Array.isArray(s) ? s.map(safe) : safe(s), x, yy, opt);

      doc.setFont('helvetica', 'bold'); doc.setFontSize(24); text('AIRE', M, y);
      doc.setFont('helvetica', 'normal'); doc.setFontSize(9); doc.setTextColor(90);
      text([CTX.shopDomain || 'aire-shop.com', CTX.shopEmail || '', CTX.shopPhone || ''].filter(Boolean), M, y + 6);
      doc.setTextColor(0); doc.setFontSize(9);
      text([t('pdf_ref') + ' : ' + d.ref, t('pdf_date') + ' : ' + dateStr, t('pdf_valid')], W - M, y, { align: 'right' });
      y += 22;
      doc.setFont('helvetica', 'bold'); doc.setFontSize(12); text(t('pdf_doc_title'), W / 2, y, { align: 'center' });
      y += 4; doc.setDrawColor(30, 64, 175); doc.setLineWidth(0.6); doc.line(M, y, W - M, y); y += 9;

      doc.setFontSize(10); doc.setFont('helvetica', 'bold'); text(t('pdf_client'), M, y);
      doc.setFont('helvetica', 'normal'); doc.setFontSize(9.5);
      const client = [];
      if (d.company) client.push(d.company);
      if (d.name) client.push(d.name);
      if (d.email || d.phone) client.push([d.email, d.phone].filter(Boolean).join(' - '));
      client.push([[d.cp, d.city].filter(Boolean).join(' '), d.destName].filter(Boolean).join(', '));
      if (d.vat.given) client.push(t('pdf_vat') + ' : ' + d.vat.value + ((d.vat.formatOk && d.vat.countryOk) ? '' : ' ' + t('pdf_tva_check')));
      y += 5.5; client.forEach((l) => { text(l, M, y); y += 5; }); y += 4;

      doc.setFont('helvetica', 'bold'); doc.setFontSize(10); text(t('pdf_config'), M, y);
      doc.setFont('helvetica', 'normal'); doc.setFontSize(9.5); y += 5.5;
      if (d.preview) {
        const maxW = W - 2 * M, maxH = 72;
        let imgW = maxW, imgH = imgW * d.preview.height / d.preview.width;
        if (imgH > maxH) { imgH = maxH; imgW = imgH * d.preview.width / d.preview.height; }
        if (y + imgH > 250) { doc.addPage(); y = 20; }
        const imgX = (W - imgW) / 2;
        doc.addImage(d.preview.dataUrl, 'PNG', imgX, y, imgW, imgH, undefined, 'FAST');
        y += imgH + 6;
      }
      d.cfgLines.forEach((l) => { const wrapped = doc.splitTextToSize(safe(l), W - 2 * M); doc.text(wrapped, M, y); y += 5 * wrapped.length; });
      y += 5;

      const rowH = 8, xQty = 118, xPU = 138, xTot = 168;
      doc.setFillColor(239, 246, 255); doc.rect(M, y, W - 2 * M, rowH, 'F');
      doc.setFont('helvetica', 'bold'); doc.setFontSize(9);
      text(t('pdf_col_desc'), M + 2, y + 5.4); text(t('pdf_qty'), xQty, y + 5.4); text(t('pdf_unit_ht'), xPU, y + 5.4); text(t('pdf_total_ht'), xTot, y + 5.4);
      y += rowH; doc.setFont('helvetica', 'normal');
      d.rows.forEach((r) => {
        const desc = doc.splitTextToSize(safe(r.desc), 92);
        const rH = Math.max(rowH, 5 * desc.length + 3);
        if (y + rH > 262) { doc.addPage(); y = 20; }
        doc.text(desc, M + 2, y + 5.4); text(String(r.qty), xQty, y + 5.4); text(money(r.unitHT), xPU, y + 5.4); text(money(r.totalHT), xTot, y + 5.4);
        y += rH;
      });
      doc.setDrawColor(200); doc.setLineWidth(0.2); doc.line(M, y, W - M, y); y += 6;
      if (y > 240) { doc.addPage(); y = 20; }
      doc.setFontSize(9.5);
      text(t('pdf_total_ht'), xPU, y); text(money(d.totalHT), W - M, y, { align: 'right' }); y += 5.5;
      text(t('pdf_vat') + ' (' + String(d.rate).replace('.', ',') + ' %)', xPU, y); text(money(d.tvaAmt), W - M, y, { align: 'right' }); y += 6;
      doc.setFont('helvetica', 'bold'); doc.setFontSize(11);
      text(t('pdf_total_ttc'), xPU, y); text(money(d.totalTTC), W - M, y, { align: 'right' }); y += 9;

      doc.setFont('helvetica', 'italic'); doc.setFontSize(8.5); doc.setTextColor(60);
      const men = doc.splitTextToSize(safe(d.mention), W - 2 * M); doc.text(men, M, y); y += 4.2 * men.length + 4;
      if (d.link) { doc.setFont('helvetica', 'normal'); doc.setFontSize(7.5); doc.setTextColor(100); const lk = doc.splitTextToSize(safe(t('pdf_link') + ' ' + d.link), W - 2 * M); doc.text(lk, M, y); y += 3.6 * lk.length + 4; }

      doc.setFontSize(7.5); doc.setTextColor(120);
      const legal = CTX.legal || {};
      const footer = t('pdf_disclaimer') + '\n' + [legal.raison, legal.adresse, legal.siren ? 'SIREN ' + legal.siren : '', legal.tva ? 'N° TVA ' + legal.tva : ''].filter(Boolean).join(' - ');
      const fLines = doc.splitTextToSize(safe(footer), W - 2 * M);
      doc.text(fLines, M, 285 - 3.4 * fLines.length);
      doc.save(d.ref + '-aire-pegboard.pdf');
    }

    btn.addEventListener('click', () => {
      showErr('');
      const d = collect();
      if (d.unitDisplayed <= 0) { showErr(t('pdf_err_price')); return; }
      if (d.warning) showErr(d.warning); /* avertissement non bloquant */
      btn.disabled = true;
      Promise.all([loadJsPdf(), configurationImage()]).then((results) => {
        d.preview = results[1];
        if (!d.preview) throw new Error('configuration preview unavailable');
        buildPdf(d);
      }).catch((e) => { console.error('[pegconf-pdf]', e); showErr(t('pdf_error')); }).then(() => { btn.disabled = false; });
    });
  }

  const boot = () => { if (window.PEGCONF_UI) start(); else document.addEventListener('pegconf:ui-ready', start, { once: true }); };
  if (window.PEGCONF) window.PEGCONF.ready(boot); else document.addEventListener('pegconf:ready', boot, { once: true });
})();
